import {
  RESET_REDUX,
  REQUEST_PROTOCOLS_LIST,
  RECEIVE_PROTOCOLS_LIST,
  REQUEST_PRESET_LOCATIONS,
  RECEIVE_PRESET_LOCATIONS,
  RESET_PROTOCOLS_LIST,
  ADD_CUSTOM_PROTOCOL_TO_REDUX,
} from "../actions/index";
import produce from "immer";

const initialState = {
  protocolsListReceived: true,
  protocolsListFetching: false,
  protocolsById: {
    TRAINING_PROTOCOL: {
      protocolId: "TRAINING_PROTOCOL",
      protocolName: "Training Protocol",
    },
  },
  presetLocationsFetching: false,
  presetLocationsReceived: true,
  presetLocations: [],
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ADD_CUSTOM_PROTOCOL_TO_REDUX: {
        draft.protocolsById[action.customProtocol.protocolId] =
          action.customProtocol;
        break;
      }
      case REQUEST_PROTOCOLS_LIST: {
        draft.protocolsListFetching = true;
        draft.protocolsListReceived = false;
        break;
      }
      case RECEIVE_PROTOCOLS_LIST: {
        draft.protocolsListFetching = false;
        draft.protocolsById = action.protocols;
        draft.protocolsListReceived = true;
        break;
      }
      case RESET_PROTOCOLS_LIST: {
        draft.protocolsListFetching = false;
        draft.protocolsListReceived = false;
        break;
      }

      case REQUEST_PRESET_LOCATIONS: {
        draft.presetLocationsFetching = true;
        break;
      }

      case RECEIVE_PRESET_LOCATIONS: {
        draft.presetLocationsFetching = false;
        draft.presetLocationsReceived = true;
        draft.presetLocations = action.presetLocations;
        break;
      }

      case RESET_REDUX:
        let renewState = {};
        renewState = {
          ...initialState,
          protocolsById: draft.protocolsById,
        };
        return renewState;
      default:
        return draft;
    }
  });
